import {
  Backdrop,
  Divider,
  Fade,
  Modal,
  Typography
} from "@material-ui/core";
import React from "react";
import { addBalanceModalStyle } from "./AddBalanceModalStyle";
import {useSelector} from "react-redux";
import AddCardForm from "./cardComponent/AddCardForm";
import ElementsWrapper from "./cardComponent/ElementsWrapper";

const AddPaymentMethodModal = ({ open, onClose, loadData }) => {
  const {userCardInfo} = useSelector((state)=>(state.billingReducer));

  const classes = addBalanceModalStyle();

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <ElementsWrapper
              stripePublicKey={userCardInfo?.stripePublicKey}
              stripeAccountId={userCardInfo?.stripeConnectId}
          >
            <div className={classes.paper} style={{ width: 600 }}>
              <div className={classes.modalHeader}>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <img
                      width={50}
                      src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/billing/1.0.0/card_icon.png`}
                      alt=""
                  />

                  <div>
                    <Typography
                        style={{
                          height: "unset !important",
                          color: "black",
                          fontWeight: 600,
                        }}
                        variant="h5"
                    >
                      Add new payment method
                    </Typography>
                    <div style={{ fontSize: 16, fontWeight: 300 }}>
                      Please provide the bellow details
                    </div>
                  </div>
                </div>
              </div>
              <Divider />
              <AddCardForm
                  handleClose={handleClose}
                  onSuccess={() => {
                    handleClose();
                    if (loadData){
                        loadData();
                    }
                  }}
              />
            </div>
          </ElementsWrapper>
        </Fade>
      </Modal>
    </>
  );
};

export default AddPaymentMethodModal;
